export default "/build/images/028-1-150x150.png?f9f882f121f890f22eb41886b2986777";